<!--

Pass an array of objects representing the options, in this form:

[
  { id: 4, name: "Active" },
  { id: 7, name: "New" },
  ...
]

-->

<template lang="pug">

div.condition.foreign-key-filter

  v-select.filter__operator(
    :items="operators"
    item-text="name"
    v-model="selectedOperator"
    @input="changedOperator"
    return-object
  )

  .filter__value(v-if="selectedOperator && selectedOperator.needValue")
    v-autocomplete.search(
      v-model="selectedValue"
      :items="options"
      item-text="name"
      item-value="id"
      attach
      clearable
      deletable-chips
      open-on-clear
      small-chips
      multiple
    )

</template>

<script>

import {
  ExactMatchQueryBuilder,
} from '@/Core/utilities/filter-query-builders/ExactMatchQueryBuilder';

export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Array,
      default: () => [],
    },
    operators: {
      type: Array,
      default: () => ExactMatchQueryBuilder.OperatorList,
    },
  },
  data() {
    return {
      /**
       * The operator from the list that's been selected
       * @type {Object}
       */
      selectedOperator: {},

      /**
       * The selected condition (operand and value)
       * @type {Object}
       */
      selectedValue: [],

    };
  },
  mounted() {
    this.selectedValue = this.value.value ? [...this.value.value] : [];
    this.setSelectedOperator();

    if (this.noValueGiven()) {
      this.selectedValue = [];
    }

    this.$watch('selectedOperator', (operator, prev) => {
      this.emitSelected();
    });

    this.$watch('selectedValue', selectedValue => {
      this.emitSelected();
    });
  },

  methods: {

    /**
     * The operator has been changed; update/clear the value as necessary
     * @param  {} operator
     * @return {}
     */
    changedOperator(operator) {
      if (operator.needValue === false) {
        this.selectedValue = [];
      }
    },

    /**
     * Set the selected operator depending on what's been
     * passed in as selected
     */
    setSelectedOperator() {
      this.selectedOperator = this.operators.find(operator => {
        return operator.name === this.value.operator;
      });
    },

    /**
     * Check if any value is set
     * @return {Boolean}
     */
    noValueGiven() {
      return !this.selectedValue;
    },

    /**
     * Wrapper to emit condition operator & value
     */
    emitSelected() {
      this.$emit('input', {
        operator: this.selectedOperator.name,
        value: this.selectedValue,
      });
    },
  },
};
</script>
